import React from 'react';
import IconFacebook from '../svgs/fb.svg';
import IconInstagram from '../svgs/instagram.svg';
import IconYoutube from '../svgs/yt.svg';

const iconHeight = 42;

function SocialIcons() {
  return (
    <div className="flex">
      <a
        href="https://www.facebook.com/sportdogbrand"
        rel="noopener noreferrer"
        target="_blank"
        className="w-10 h-10 mx-[1.5vw] md:ml-0 md:mr-[0.5vw]"
      >
        <IconFacebook width={iconHeight} height={iconHeight} />
      </a>
      <a
        href="https://www.instagram.com/sportdogbrand/"
        rel="noopener noreferrer"
        target="_blank"
        className="w-10 h-10 mx-[1.5vw] md:ml-0 md:mr-[0.5vw]"
      >
        <IconInstagram width={iconHeight} height={iconHeight} />
      </a>
      <a
        href="https://www.youtube.com/user/sportdogbrand/"
        rel="noopener noreferrer"
        target="_blank"
        className="w-10 h-10 mx-[1.5vw] md:ml-0 md:mr-[0.5vw]"
      >
        <IconYoutube width={iconHeight} height={iconHeight} />
      </a>
    </div>
  );
}

export default SocialIcons;
